import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSession } from "@/app/session";
import { useT } from "@/lib/i18n";
import { GUIDE_SEEN_KEY } from "@/pages/Guide";
import { Button } from "./ui";

/** Offered once per user (per browser): open the guide or jump straight in. */
export function WelcomeModal() {
  const { me } = useSession();
  const t = useT();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!me) return;
    if (
      location.pathname.startsWith("/guia") ||
      location.pathname.startsWith("/print/") ||
      location.pathname.startsWith("/s/")
    )
      return;
    try {
      if (!localStorage.getItem(GUIDE_SEEN_KEY(me.user.id))) setOpen(true);
    } catch {}
  }, [me]);
  if (!open || !me) return null;
  const done = () => {
    try {
      localStorage.setItem(GUIDE_SEEN_KEY(me.user.id), "1");
    } catch {}
    setOpen(false);
  };
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="w-full max-w-md rounded-md border border-border bg-panel p-6 shadow-panel">
        <div className="wordmark mb-1 text-2xl">.MAYUSCULANOTE</div>
        <h2 className="display mb-3 text-3xl">.{t.welcomeTitle(me.user.name.split(" ")[0] ?? "")}</h2>
        <ul className="mb-5 list-disc space-y-1 pl-5 text-sm text-muted">
          {t.welcomePoints.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={done}>
            {t.welcomeSkip}
          </Button>
          <Button
            onClick={() => {
              done();
              nav("/guia");
            }}
          >
            {t.welcomeGuide}
          </Button>
        </div>
      </div>
    </div>
  );
}
